import { SVGProps } from 'react';

const BoxIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || '29'}
      height={props?.height || '28'}
      viewBox="0 0 29 28"
      fill="none"
    >
      <path
        d="M25.4571 20.1597V7.38655L14.3952 1L3.33337 7.38655V20.1597L14.3952 26.5463L25.4571 20.1597Z"
        stroke={props?.fill || 'black'}
        strokeWidth="1.64017"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33337 7.38672L14.3952 13.7733M14.3952 13.7733L25.4571 7.38672M14.3952 13.7733V26.5465"
        stroke={props?.fill || 'black'}
        strokeWidth="1.64017"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BoxIcon;
